import Backbone from 'backbone';

class NavView extends Backbone.View {
	constructor(options = {}) {
		super(options);
		this.template = null;
		this.pubSub = options.pubSub;
		this.bindings();
		this.listeners();
		this.postInitialize(options);
		this.renderPage = true;
		this.trigger('initialize');
	}

	el() { return '#main-header'; }

	events() {
		return {
			'click #toggle-btn': 'handleToggleBtnClick',
			'click .nav-btn': 'handleNavBtnClick',
			'click .subnav-btn': 'handleNavBtnClick',
			'click #logo': 'handleNavBtnClick'
		};
	}

	postInitialize() { }

	bindings() {
		//_.bindAll(this, 'render', 'destroy');
	}

	listeners() {
		this.listenTo(this.pubSub, "pageChange", this.handlePageChange, this);
		this.listenTo(this.pubSub, "pageRenderComplete", this.handlePageRenderComplete, this);
		this.listenTo(this.pubSub, "overlayShow", this.handleOverlayShow, this);
		this.listenTo(this.pubSub, "toutOverlayShow", this.handleToutOverlayShow, this);
		this.listenTo(this.pubSub, "overlayHide", this.handleOverlayHide, this);
		this.listenTo(this.pubSub, "toutOverlayHide", this.handleToutOverlayHide, this);
	}

	render() {
		const self = this;

		this.$window = $(window);
		this.$toggleBtn = $('#toggle-btn', this.$el);
		this.$html = $('html');
		this.$body = $('body');
		this.$headerContentWrap = $('#header-content-wrap', this.$el);
		this.$mainHeaderContent = $('#main-header-content', this.$headerContentWrap);
		this.$logoHolder = $('#logo-holder', this.$headerContentWrap);
		this.$navWrap = $('#nav-wrap', this.$mainHeaderContent);
		this.$expandCover = $('#expand-cover', this.$el);
		this.$mainMenu = $('#main-menu', this.$navWrap);
		this.$socialMenu = $('#social-menu', this.$navWrap);
		this.$containerMain = $('#container-main'); // outside of el
		this.$navMarker = $('#nav-marker', this.$containerMain); // this will change but always be the same id`
		this.navLocked = false;
		this.isDesktop = false;
		this.scrollPos = 0; // position to scroll to on hide
		this.overlayOpen = false;

		// set data-href properties for each nav button - set to 'active' when 'pageChange' event fires
		this.$buttonListItems = document.querySelectorAll('#main-menu>li a');

		this.$buttonListItems.forEach(button => {
			button.dataset.href = button.getAttribute('href').replace(/^\//, '').replace('#!\/', '').replace('#', '');
		});

		//determine active buttons
		this.$activeButtonListItems = document.querySelectorAll('#main-menu>li a.active');

		// resize without awkward shifts between breakpoints
		window.addEventListener('resize', () => {
			//prevent transitions during resize
			this.$mainHeaderContent.addClass('notransition');
			// is this the desktop view?
			if (window.innerWidth >= 992) {
				if (!this.isDesktop) {
					// update
					this.isDesktop = true;
					window.dispatchEvent(new Event('scroll.parallax'));
				}
			} else {
				if (this.isDesktop) {
					// update
					this.isDesktop = false;
					window.dispatchEvent(new Event('scroll.parallax'));
				}
			}

			//force a reflow so that there's no css transition here
			/* jshint ignore:start */
			this.$mainHeaderContent.offsetHeight;
			this.$mainHeaderContent.removeClass('notransition');
			/* jshint ignore:end */
			// if this is a desktop view, and showing, and not following, then remove the nav show classes
			if (this.isDesktop && this.el.classList.contains('showing') && !this.el.classList.contains('follow')) {
				this.pubSub.trigger('overlayShow');
				this.el.classList.toggle('showing');
			}
		});

		return self;
	}

	handlePageChange(obj) {
		// clear active buttons
		this.$activeButtonListItems.forEach(button => {
			button.classList.remove('active');
		});

		// check for buttons to activate
		this.$buttonListItems.forEach(button => {
			if (obj.page === button.dataset.href) {
				button.classList.add('active');
			}
		});

		//update active buttons
		this.$activeButtonListItems = document.querySelectorAll('#main-menu>li a.active');
		if (!obj.initialPage) {
			// don't trigger this if this is the initial page render
			this.closeToggleBtn();
		}
	}

	handleToggleBtnClick() {
		if (!this.overlayOpen) {
			this.pubSub.trigger('overlayShow'); // event also triggered from modal-manager
		} else {
			this.pubSub.trigger('overlayHide'); // event also triggered from modal-manager
		}
		this.overlayOpen = !this.overlayOpen;
		this.el.classList.toggle('showing');
	}

	handlePageRenderComplete() {
		// update $navMarker
		this.$navMarker = document.querySelector('#nav-marker');
	}

	handleOverlayShow() {
		/*
		// assign the current top to body
		this.scrollPos = window.scrollY;
		this.$html.toggleClass('nav-show').css('top', '-' + this.scrollPos + 'px');
		*/
		this.$html.toggleClass('nav-show');
	}

	handleToutOverlayShow() {
		/*
		this.scrollPos = window.scrollY;
		this.$html.toggleClass('tout-show').css('top', '-' + this.scrollPos + 'px');
		*/
		this.$html.toggleClass('nav-show');
	}

	handleOverlayHide() {
		//clear top value
		/*
		this.$html.removeClass('nav-show').css('top', '');
		this.$html.scrollTop(Math.round(this.scrollPos));
		this.$html.scrollTop(Math.round(this.scrollPos));
		*/
		this.$html.removeClass('nav-show');
		// reset scrollPos
		this.scrollPos = 0;
	}

	handleToutOverlayHide() {
		// only reset scrolling if there's not something else blocking scrolling
		if (!this.$html.hasClass('nav-show')) {
			//clear top value
			this.$html.removeClass('tout-show');
			//this.$html.style.top = '';
			//window.scrollTo(0, this.scrollPos);
			// reset scrollPos
			this.scrollPos = 0;
		} else {
			// just clear the tout-show class
			this.$html.removeClass('tout-show');
		}
	}

	handleNavBtnClick() {
		this.closeToggleBtn();
	}

	closeToggleBtn() {
		this.pubSub.trigger('overlayHide'); // event also triggered from modal-manager
		this.overlayOpen = false;
		this.el.classList.remove('showing');
	}

	cleanup() {
		//clear additional listeners
	}
}

export default NavView;